import React from 'react';
import { graphql } from 'gatsby';

import Accordion from '@components/Accordion';
import { Grid } from '@components/Grid';
import Layout from '@components/Layout';
import SEO from '@components/SEO';

const Faqs = ({
    data: {
        markdownRemark: {
            frontmatter: { title, items },
        },
    },
}) => {
    if (!items || !items?.length) return null;

    const Items = items.map(({ faq_items_question: question, faq_items_answer: answer }, index) => (
        <Accordion key={index} title={question} text={answer} />
    ));

    return (
        <Layout>
            <SEO title="Frequently Asked Questions" />
            <div>
                <Grid>
                    <h1>{title}</h1>
                    {Items}
                </Grid>
            </div>
        </Layout>
    );
};

export default Faqs;

export const query = graphql`
    query {
        markdownRemark(fileAbsolutePath: { regex: "/faqs/" }) {
            frontmatter {
                title: faq_title
                items: faq_items {
                    faq_items_question
                    faq_items_answer
                }
            }
        }
    }
`;
